
namespace Matrix.Indexation {
    export class BasketConstituentColumns {
        static columnsKey = 'Indexation.BasketConstituent';
    }
}